import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

import { User } from "../models/auth.models";
import { FirebaseService } from "./firebase.service";

@Injectable({ providedIn: "root" })
export class AuthfakeauthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private firebaseService: FirebaseService) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser")),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public getUser() {
    return JSON.parse(localStorage.getItem("currentUser"));
  }

  login(user) {
    let content = user;
    content.token = user.jwtToken.token;

    if (content && content.token) {
      localStorage.setItem("currentUser", JSON.stringify(content));
      this.currentUserSubject.next(content);
    }
    return content;
  }

  updateUserLanguage(user: User) {
    const currentUser = this.getUser();
    currentUser.language = user.language;

    localStorage.setItem("currentUser", JSON.stringify(currentUser));
    this.currentUserSubject.next(currentUser);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    this.firebaseService.clearAndDestroy();
    this.currentUserSubject.next(null);
  }
}
